/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { Type } from '@app/settings/types/types.model';
import { Logger } from '@app/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TypesService } from '@app/settings/types/types.service';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';

const log = new Logger('facilitiesFormComponent');

@Component({
  selector: 'app-types-form',
  templateUrl: './types-form.component.html',
  styleUrls: ['./types-form.component.scss'],
})
export class TypesFormComponent implements OnInit {
  @Input() type: Type = null;
  form: FormGroup;
  data: Array<string>;
  loader: boolean;

  constructor(public modal: NgbActiveModal, private formBuilder: FormBuilder, private typesService: TypesService) {}

  ngOnInit() {
    this.loadTypes();
    this.createForm();
  }

  save() {
    log.debug(this);
    if (this.type) {
      const type: Type = this.type.deserialize(this.form.value);
      this.typesService.update(type).subscribe((res) => this.modal.close('Save click'));
    } else {
      const type: Type = new Type().deserialize(this.form.value);
      this.typesService.store(type).subscribe((res) => this.modal.close('Save click'));
    }
  }

  loadTypes() {
    this.loader = true;
    this.typesService.groups().subscribe((response: PaginatedResponse) => {
      this.data = response.data.map((type: any) => type.type);
      this.loader = false;
    });
  }

  test() {
    log.debug(this.form);
  }

  private createForm() {
    this.form = this.formBuilder.group({
      id: [null],
      value: [null, [Validators.required]],
      color: ['#ffffff', [Validators.required]],
      type: [null, [Validators.required]],
      active: [true],
      icon: [null],
      order_index: [null],
      real_value: [null],
    });

    if (this.type) {
      this.form.patchValue(this.type);
    }
  }
}
